import React from "react";
import { Box, Button } from "@mui/material";

const Pagination = ({ page, setPage, totalPages, maxButtons = 5 }) => {
  const currentPage = Number(page);
  const lastPage = Number(totalPages);
console.log("[[[[[lastPage]]]]]",lastPage)
  if (lastPage < 1) return null; // no pagination needed

  // Calculate start and end of page range
  let startPage = Math.max(currentPage - Math.floor(maxButtons / 2), 1);
  let endPage = startPage + maxButtons - 1;

  if (endPage > lastPage) {
    endPage = lastPage;
    startPage = Math.max(endPage - maxButtons + 1, 1);
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 2,
        gap: 1,
        flexWrap: "wrap",
      }}
    >
      {/* First Page */}
      <Button
        variant="outlined"
        size="small"
        disabled={currentPage === 1}
        onClick={() => setPage(1)}
      >
        «
      </Button>

      {/* Previous Page */}
      <Button
        variant="outlined"
        size="small"
        disabled={currentPage === 1}
        onClick={() => setPage(Math.max(currentPage - 1, 1))}
      >
        ‹
      </Button>

      {/* Left Ellipsis */}
      {startPage > 1 && (
        <Button variant="text" size="small" disabled>
          …
        </Button>
      )}

      {/* Page Numbers */}
      {pages.map((p) => (
        <Button
          key={p}
          variant={p === currentPage ? "contained" : "outlined"}
          size="small"
          onClick={() => setPage(p)}
        >
          {p}
        </Button>
      ))}

      {/* Right Ellipsis */}
      {endPage < lastPage && (
        <Button variant="text" size="small" disabled>
          …
        </Button>
      )}

      {/* Next Page */}
      <Button
        variant="outlined"
        size="small"
        disabled={currentPage === lastPage}
        onClick={() => setPage(Math.min(currentPage + 1, lastPage))}
      >
        ›
      </Button>

      {/* Last Page */}
      <Button
        variant="outlined"
        size="small"
        disabled={currentPage === lastPage}
        onClick={() => setPage(lastPage)}
      >
        »
      </Button>
    </Box>
  );
};

export default Pagination;
